import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cb15ed9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-cloud-upload-outline uploadDragImage" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "horizontal-line" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "content-error-messages"
}
const _hoisted_8 = { class: "p-grid p-jc-between errorMessages" }
const _hoisted_9 = { class: "p-col-9" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "p-col-3 p-text-right p-as-center"
}
const _hoisted_13 = { class: "p-grid p-jc-between errorMessages" }
const _hoisted_14 = { class: "p-col-9" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { class: "p-col-3 p-text-right p-as-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "p-p-2"
}
const _hoisted_22 = {
  key: 0,
  class: "viewer",
  ref: "viewer"
}
const _hoisted_23 = {
  key: 0,
  class: "content"
}
const _hoisted_24 = { class: "scroll-content p-shadow-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_TieredMenu = _resolveComponent("TieredMenu")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_HeadTraining = _resolveComponent("HeadTraining")!
  const _component_PositionTraining = _resolveComponent("PositionTraining")!
  const _component_FormHeadTraining = _resolveComponent("FormHeadTraining")!
  const _component_FormPositionTraining = _resolveComponent("FormPositionTraining")!
  const _component_OcrView = _resolveComponent("OcrView")!
  const _component_LocatorTesting = _resolveComponent("LocatorTesting")!
  const _component_DocumentSplit = _resolveComponent("DocumentSplit")!
  const _component_ValidationFieldSet = _resolveComponent("ValidationFieldSet")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_ValidationFieldSetWithoutLayout = _resolveComponent("ValidationFieldSetWithoutLayout")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ValidationFieldSetSkeleton = _resolveComponent("ValidationFieldSetSkeleton")!
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")!
  const _component_Viewer = _resolveComponent("Viewer")!
  const _component_SqueezeViewer = _resolveComponent("SqueezeViewer")!
  const _component_Splitter = _resolveComponent("Splitter")!
  const _component_ValidationTable = _resolveComponent("ValidationTable")!
  const _component_HotKeyList = _resolveComponent("HotKeyList")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_LogView = _resolveComponent("LogView")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_DialogOptionsConfirm = _resolveComponent("DialogOptionsConfirm")!
  const _component_ValidationEmailView = _resolveComponent("ValidationEmailView")!
  const _component_DocumentClassChangeForm = _resolveComponent("DocumentClassChangeForm")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _component_DialogLocked = _resolveComponent("DialogLocked")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isUploadShown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["dragFiles", { drag: _ctx.showDragDialog }]),
          onDragenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDragEnter && _ctx.onDragEnter(...args))),
          onDragleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
          onDrop: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
        }, _hoisted_2, 34))
      : _createCommentVNode("", true),
    _createVNode(_component_Splitter, {
      layout: "vertical",
      gutterSize: 10,
      stateStorage: "local",
      stateKey: "squeeze.validation.verticalSplitterLayout",
      class: _normalizeClass(["root-splitter", _ctx.activeTable && _ctx.activeTable.hidden ? 'disabled-splitter-gutter' : '']),
      onMousedown: _ctx.onSplitterMouseDown,
      onMouseup: _ctx.onSplitterMouseUp,
      onResizeend: _ctx.onSplitterResizeEnd
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SplitterPanel, {
          class: "inherit-height p-d-flex",
          size: 80,
          minSize: 50
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Splitter, {
              gutterSize: 10,
              stateStorage: "local",
              stateKey: "squeeze.validation.horizontalSplitterLayout",
              onMousedown: _ctx.onSplitterMouseDown,
              onMouseup: _ctx.onSplitterMouseUp,
              onResizeend: _ctx.onSplitterResizeEnd
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SplitterPanel, {
                  class: "p-d-flex",
                  size: 33,
                  minSize: 30,
                  ref: "leftSplitterPanel"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "content",
                      style: _normalizeStyle({'width': _ctx.leftSplitterPanelWidth > 0 ? _ctx.leftSplitterPanelWidth + 'px' : '100%'})
                    }, [
                      _createVNode(_component_Toolbar, { class: "p-p-2" }, {
                        start: _withCtx(() => [
                          (_ctx.hideValidationButtons)
                            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                class: "p-shadow-4 p-button-md",
                                icon: !_ctx.hideValidationButtons ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-left',
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (!_ctx.hideValidationButtons ? _ctx.goBackToValidationList() : _ctx.reopenValidationView()))
                              }, null, 8, ["icon"])), [
                                [_directive_tooltip, _ctx.$t('Squeeze.General.Back')]
                              ])
                            : _createCommentVNode("", true),
                          (!_ctx.hideValidationButtons)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _withDirectives(_createVNode(_component_Button, {
                                  class: "p-shadow-4",
                                  icon: "mdi mdi-chevron-double-up",
                                  onClick: _ctx.goBackToValidationList,
                                  disabled: _ctx.disableBrowseButtons
                                }, null, 8, ["onClick", "disabled"]), [
                                  [_directive_tooltip, _ctx.$t('Squeeze.Validation.Buttons.BackToList')]
                                ]),
                                _withDirectives(_createVNode(_component_Button, {
                                  class: "p-shadow-4 p-ml-1",
                                  icon: "mdi mdi-chevron-left",
                                  onClick: _ctx.browseLeft,
                                  disabled: _ctx.disableBrowseButtons || _ctx.blockBrowseButtons
                                }, null, 8, ["onClick", "disabled"]), [
                                  [_directive_tooltip, _ctx.$t('Squeeze.Validation.Buttons.PrevDocument')]
                                ]),
                                _withDirectives(_createVNode(_component_Button, {
                                  class: "p-shadow-4 p-ml-1",
                                  icon: "mdi mdi-chevron-right",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToNextDocument(false))),
                                  disabled: _ctx.disableBrowseButtons || _ctx.blockBrowseButtons
                                }, null, 8, ["disabled"]), [
                                  [_directive_tooltip, _ctx.$t('Squeeze.Validation.Buttons.NextDocument')]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        end: _withCtx(() => [
                          (_ctx.hideValidationButtons && _ctx.showHeadTraining || _ctx.showPositionTraining || _ctx.showFormHeadTraining || _ctx.showFormPositionTraining || _ctx.showOcrResults || _ctx.showLocatorTest)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _withDirectives(_createVNode(_component_Button, {
                                  class: "p-shadow-4 p-button-md",
                                  type: "button",
                                  icon: "mdi mdi-dots-vertical",
                                  onClick: _ctx.toggleToolBarOptions,
                                  "aria-haspopup": "true",
                                  "aria-controls": "overlayMenu",
                                  disabled: _ctx.blocked.buttons.menu
                                }, null, 8, ["onClick", "disabled"]), [
                                  [_directive_tooltip, _ctx.$t('Squeeze.General.Options')]
                                ]),
                                _createVNode(_component_TieredMenu, {
                                  id: "overlayTMenu1",
                                  ref: "menu",
                                  model: _ctx.toolbarOptions,
                                  popup: "",
                                  style: {"border":"none","max-height":"80vh"}
                                }, null, 8, ["model"])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.hideValidationButtons)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_Button, {
                                  id: "btnValidation",
                                  class: _normalizeClass(["p-button-md p-mr-1", _ctx.blocked.buttons.save ? 'p-button-text' : 'p-shadow-4']),
                                  onClick: _ctx.validateAndExportDocument,
                                  label: _ctx.toolbarButtonText ? _ctx.validationValidateButtonSettings.description : null,
                                  icon: _ctx.validationValidateButtonSettings.icon,
                                  style: _normalizeStyle(_ctx.validationValidateButtonSettings.color),
                                  disabled: _ctx.blocked.buttons.save
                                }, null, 8, ["class", "onClick", "label", "icon", "style", "disabled"]),
                                _createVNode(_component_Button, {
                                  class: _normalizeClass(["p-button-md p-mr-1", _ctx.blocked.buttons.suspend ? 'p-button-text' : 'p-shadow-4']),
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.showDialog('suspendDocument'); _ctx.removeFocusOnBtnAfterClick($event);}),
                                  label: _ctx.toolbarButtonText ? _ctx.validationSuspendButtonSettings.description : null,
                                  icon: _ctx.validationSuspendButtonSettings.icon,
                                  style: _normalizeStyle(_ctx.validationSuspendButtonSettings.color),
                                  disabled: _ctx.blocked.buttons.suspend
                                }, null, 8, ["class", "label", "icon", "style", "disabled"]),
                                _createVNode(_component_Button, {
                                  class: _normalizeClass(["p-button-md p-mr-1", _ctx.blocked.buttons.delete ? 'p-button-text' : 'p-shadow-4']),
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.showDialog('deleteDocument'); _ctx.removeFocusOnBtnAfterClick($event);}),
                                  label: _ctx.toolbarButtonText ? _ctx.validationDeleteButtonSettings.description : null,
                                  icon: _ctx.validationDeleteButtonSettings.icon,
                                  style: _normalizeStyle(_ctx.validationDeleteButtonSettings.color),
                                  disabled: _ctx.blocked.buttons.delete
                                }, null, 8, ["class", "label", "icon", "style", "disabled"]),
                                (!_ctx.autoDocumentValidation)
                                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      class: "p-button-md p-mr-1 p-shadow-4",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.validateDocument(true); _ctx.removeFocusOnBtnAfterClick($event);}),
                                      icon: "mdi mdi-file-check-outline",
                                      severity: "warning",
                                      disabled: _ctx.blocked.buttons.checkDocument
                                    }, null, 8, ["disabled"])), [
                                      [_directive_tooltip, _ctx.$t('Squeeze.Validation.Buttons.CheckDocument')]
                                    ])
                                  : _createCommentVNode("", true),
                                _withDirectives(_createVNode(_component_Button, {
                                  class: "p-shadow-4 p-button-md p-mr-1",
                                  type: "button",
                                  icon: "mdi mdi-dots-vertical",
                                  onClick: _ctx.toggleToolBarOptions,
                                  "aria-haspopup": "true",
                                  "aria-controls": "overlayMenu",
                                  disabled: _ctx.blocked.buttons.menu
                                }, null, 8, ["onClick", "disabled"]), [
                                  [_directive_tooltip, _ctx.$t('Squeeze.General.Actions')]
                                ]),
                                _createVNode(_component_TieredMenu, {
                                  id: "overlayTMenu",
                                  ref: "menu",
                                  model: _ctx.toolbarOptions,
                                  popup: "",
                                  style: {"border":"none","max-height":"80vh"}
                                }, null, 8, ["model"]),
                                (_ctx.currentDocument?.documentType && _ctx.currentDocument?.documentType !== _ctx.documentTypeEnum.Pdf )
                                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      class: "p-shadow-4 p-button-md",
                                      type: "button",
                                      icon: "mdi mdi-file-question-outline",
                                      severity: "secondary",
                                      style: _normalizeStyle(_ctx.btnDocumentTypeBackgroundColor(_ctx.currentDocument.xmlValidationState)),
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.removeFocusOnBtnAfterClick($event);})
                                    }, null, 8, ["style"])), [
                                      [_directive_tooltip, _ctx.onHoverDocumentType(_ctx.currentDocument.documentType)]
                                    ])
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _hoisted_6,
                      ((_ctx.currentDocument?.workflowContext?.step === 'Validation' || _ctx.currentDocument?.workflowContext?.step === 'Auto-Validation') && !_ctx.showHeadTraining && !_ctx.showPositionTraining && !_ctx.showFormHeadTraining && !_ctx.showFormPositionTraining && !_ctx.showOcrResults && !_ctx.showLocatorTest && !_ctx.showSplitDocument)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (((_ctx.currentDocument?.documentType === _ctx.documentTypeEnum.Xrechnung || _ctx.currentDocument?.documentType === _ctx.documentTypeEnum.Zugferd) && !(_ctx.currentDocument?.xmlValidationState === _ctx.XmlValidationStateEnum.Valid)))
                              ? (_openBlock(), _createBlock(_component_Message, {
                                  key: 0,
                                  severity: _ctx.checkSeverityForStatusMessage(),
                                  closable: false
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("ul", null, [
                                          (_ctx.currentDocument?.xmlValidationState === _ctx.XmlValidationStateEnum.Invalid)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.Validation.General.DocumentXmlValidationStateInvalid')), 1))
                                            : (_ctx.currentDocument?.xmlValidationState === _ctx.XmlValidationStateEnum.Warning)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(_ctx.$t('Squeeze.Validation.General.DocumentXmlValidationStateWarning')), 1))
                                              : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      (_ctx.NEW_SQUEEZE_VIEWER)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _withDirectives(_createVNode(_component_Button, {
                                              style: {"margin-right":"0"},
                                              icon: "mdi mdi-file-eye-outline",
                                              severity: _ctx.checkSeverityForStatusMessage(true),
                                              text: "",
                                              rounded: "",
                                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeCurrentDocumentInViewer()))
                                            }, null, 8, ["severity"]), [
                                              [_directive_tooltip, _ctx.$t('Squeeze.Validation.General.OpenDocument')]
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["severity"]))
                              : _createCommentVNode("", true),
                            ((_ctx.currentDocument?.workflowContext?.step === 'Validation' || _ctx.currentDocument?.workflowContext?.step === 'Auto-Validation') && !_ctx.showHeadTraining && !_ctx.showPositionTraining && !_ctx.showFormHeadTraining && !_ctx.showFormPositionTraining && !_ctx.showOcrResults && !_ctx.showLocatorTest && !_ctx.showSplitDocument)
                              ? (_openBlock(), _createBlock(_component_Message, {
                                  key: 1,
                                  severity: _ctx.checkErrorSeverity(),
                                  closable: false
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("ul", null, [
                                          (!_ctx.loaded)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_15, _toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1))
                                            : (!_ctx.currentErrorField && _ctx.allErrorMessages.lengthOfAllErrors > 0)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(_ctx.$t('Squeeze.Validation.General.PleaseCheckDocument')), 1))
                                              : (!_ctx.currentErrorField && _ctx.allErrorMessages.lengthOfAllErrors === 0)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(_ctx.$t('Squeeze.Validation.General.DocumentOK')), 1))
                                                : (_ctx.currentErrorField)
                                                  ? (_openBlock(), _createElementBlock("li", _hoisted_18, _toDisplayString(_ctx.currentErrorField.description) + ": " + _toDisplayString(_ctx.currentErrorField.value.errorText), 1))
                                                  : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_19, [
                                        (_ctx.allErrorMessages.lengthOfAllErrors !== 0)
                                          ? (_openBlock(), _createBlock(_component_Badge, {
                                              key: 0,
                                              value: _ctx.loaded === false ? '?' : _ctx.allErrorMessages.lengthOfAllErrors,
                                              size: !_ctx.toolbarButtonText ? '' : 'large',
                                              severity: _ctx.allErrorMessages.lengthOfAllErrors === 0 ? 'success' : 'danger',
                                              onMouseover: _ctx.toggleErrorMessages,
                                              style: {"cursor":"pointer"}
                                            }, null, 8, ["value", "size", "severity", "onMouseover"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_OverlayPanel, { ref: "opBadge" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allErrorMessages.fields, (field) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, {
                                                key: field.id
                                              }, [
                                                _createTextVNode(_toDisplayString(field.description) + ": " + _toDisplayString(field.value.errorText), 1),
                                                _hoisted_20
                                              ], 64))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 512)
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["severity"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.showLocatorTest || _ctx.showFormPositionTraining ? 'restrict-height' : (!_ctx.showHeadTraining && !_ctx.showPositionTraining && !_ctx.showFormPositionTraining && !_ctx.showOcrResults && !_ctx.showLocatorTest && !_ctx.showSplitDocument) ? 'content' : 'scroll-content'),
                        ref: "leftSplitterPanelContent"
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(!_ctx.showHeadTraining && !_ctx.showPositionTraining && !_ctx.showFormHeadTraining && !_ctx.showFormPositionTraining && !_ctx.showOcrResults && !_ctx.showLocatorTest && !_ctx.showSplitDocument && _ctx.loaded ? 'p-pl-3 p-pr-3 p-pb-3 content' :  'p-p-3 p-d-flex p-flex-column'),
                          style: _normalizeStyle(_ctx.showLocatorTest || _ctx.showFormPositionTraining ? 'height: 100%;': '')
                        }, [
                          (_ctx.showHeadTraining)
                            ? (_openBlock(), _createBlock(_component_HeadTraining, {
                                key: 0,
                                fieldTrainingValue: _ctx.trainingValues,
                                documentClassId: _ctx.documentClassId,
                                documentId: _ctx.documentId,
                                documentFields: _ctx.documentFields,
                                trainingKeyField: _ctx.trainingKeyField,
                                onOnFocusField: _ctx.onFocusFieldTraining,
                                onOnMarkRegion: _ctx.onMarkRegion
                              }, null, 8, ["fieldTrainingValue", "documentClassId", "documentId", "documentFields", "trainingKeyField", "onOnFocusField", "onOnMarkRegion"]))
                            : (_ctx.showPositionTraining)
                              ? (_openBlock(), _createBlock(_component_PositionTraining, {
                                  key: 1,
                                  documentClassId: _ctx.documentClassId,
                                  documentId: _ctx.documentId,
                                  tables: _ctx.tables,
                                  trainingKeyField: _ctx.trainingKeyField,
                                  positionTrainingValues: _ctx.positionTrainingValues,
                                  onOnChangeValues: _ctx.onChangePositionTrainingValues,
                                  onOnFocusFieldOfPositionTraining: _ctx.onFocusFieldOfPositionTraining,
                                  onOnMarkRegion: _ctx.onMarkRegion
                                }, null, 8, ["documentClassId", "documentId", "tables", "trainingKeyField", "positionTrainingValues", "onOnChangeValues", "onOnFocusFieldOfPositionTraining", "onOnMarkRegion"]))
                              : (_ctx.showFormHeadTraining)
                                ? (_openBlock(), _createBlock(_component_FormHeadTraining, {
                                    key: 2,
                                    documentClassId: _ctx.documentClassId,
                                    documentId: _ctx.documentId,
                                    documentFields: _ctx.documentFields,
                                    trainingKeyField: _ctx.trainingKeyField,
                                    headFieldOfRegionInFormTraining: _ctx.headFieldOfRegionInFormTraining,
                                    regionAnchorOfFormTraining: _ctx.regionAnchorOfFormTraining,
                                    onOnFocusField: _ctx.onFocusFieldTraining,
                                    onOnMarkRegion: _ctx.onMarkRegion
                                  }, null, 8, ["documentClassId", "documentId", "documentFields", "trainingKeyField", "headFieldOfRegionInFormTraining", "regionAnchorOfFormTraining", "onOnFocusField", "onOnMarkRegion"]))
                                : (_ctx.showFormPositionTraining)
                                  ? (_openBlock(), _createBlock(_component_FormPositionTraining, {
                                      key: 3,
                                      documentClassId: _ctx.documentClassId,
                                      documentId: _ctx.documentId,
                                      tables: _ctx.tables,
                                      trainingKeyField: _ctx.trainingKeyField,
                                      indicatorOfFormTraining: _ctx.indicatorOfFormTraining,
                                      regionAnchorOfFormTraining: _ctx.regionAnchorOfFormTraining,
                                      itemFieldOfRegionInFormTraining: _ctx.itemFieldOfRegionInFormTraining,
                                      onOnFocusField: _ctx.onFocusFieldTraining,
                                      onOnMarkRegion: _ctx.onMarkRegion
                                    }, null, 8, ["documentClassId", "documentId", "tables", "trainingKeyField", "indicatorOfFormTraining", "regionAnchorOfFormTraining", "itemFieldOfRegionInFormTraining", "onOnFocusField", "onOnMarkRegion"]))
                                  : (_ctx.showOcrResults)
                                    ? (_openBlock(), _createBlock(_component_OcrView, {
                                        key: 4,
                                        title: _ctx.$t('Squeeze.DocumentClasses.OCRResults'),
                                        documentId: _ctx.documentId,
                                        onOnMarkLines: _ctx.onMarkLines,
                                        onOnMarkWord: _ctx.onMarkWord
                                      }, null, 8, ["title", "documentId", "onOnMarkLines", "onOnMarkWord"]))
                                    : (_ctx.showLocatorTest)
                                      ? (_openBlock(), _createBlock(_component_LocatorTesting, {
                                          key: 5,
                                          documentId: _ctx.documentId,
                                          onOnMarkWord: _ctx.onMarkWord,
                                          showSingleLinedForm: _ctx.showLocatorTest
                                        }, null, 8, ["documentId", "onOnMarkWord", "showSingleLinedForm"]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                          (_ctx.showSplitDocument)
                                            ? (_openBlock(), _createBlock(_component_DocumentSplit, {
                                                key: 0,
                                                documentId: _ctx.documentId,
                                                onOnImageClick: _ctx.onSplitImageClick,
                                                onOnEmptyList: _ctx.onEmptyList
                                              }, null, 8, ["documentId", "onOnImageClick", "onOnEmptyList"]))
                                            : (_ctx.loaded)
                                              ? (_openBlock(), _createBlock(_component_TabView, {
                                                  key: 1,
                                                  activeIndex: _ctx.activeGroupTab,
                                                  "onUpdate:activeIndex": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.activeGroupTab) = $event)),
                                                  onTabChange: _ctx.focusOnFirstField,
                                                  class: "content"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.store.state.featureSet.validationFieldLayout)
                                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.documentClassFieldsByGroup, (group) => {
                                                          return (_openBlock(), _createBlock(_component_TabPanel, {
                                                            key: group.id,
                                                            header: group.description
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ValidationFieldSet, {
                                                                ref_for: true,
                                                                ref: el => { _ctx.validationFieldSet[group.id] = el },
                                                                onOnBlur: _ctx.validateDocument,
                                                                onOnFocusField: _ctx.markFieldByRegion,
                                                                onAllHeadRefFields: _ctx.allHeadRefFields,
                                                                onEnterDocumentGroup: _ctx.enterDocumentGroup,
                                                                onOnHoverItemAutocomplete: _ctx.onHoverItemAutocomplete,
                                                                class: "p-mb-2",
                                                                documentFields: _ctx.documentFields,
                                                                documentClassFields: group.fields,
                                                                id: group.id,
                                                                name: group.name,
                                                                description: group.description,
                                                                layoutDetails: _ctx.fieldLayoutComplete.fieldLayoutRows.find(layout => layout.fieldGroupId === group.id) ? _ctx.fieldLayoutComplete.fieldLayoutRows.find(layout => layout.fieldGroupId === group.id).rows : [],
                                                                isReadOnlyMode: _ctx.isReadOnlyMode,
                                                                documentId: _ctx.documentId
                                                              }, null, 8, ["onOnBlur", "onOnFocusField", "onAllHeadRefFields", "onEnterDocumentGroup", "onOnHoverItemAutocomplete", "documentFields", "documentClassFields", "id", "name", "description", "layoutDetails", "isReadOnlyMode", "documentId"])
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["header"]))
                                                        }), 128))
                                                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.documentClassFieldsByGroup, (group) => {
                                                          return (_openBlock(), _createBlock(_component_TabPanel, {
                                                            key: group.id,
                                                            header: group.description
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ValidationFieldSetWithoutLayout, {
                                                                ref_for: true,
                                                                ref: el => { _ctx.validationFieldSet[group.id] = el },
                                                                onOnBlur: _ctx.validateDocument,
                                                                onOnFocusField: _ctx.markFieldByRegion,
                                                                onAllHeadRefFields: _ctx.allHeadRefFields,
                                                                onEnterDocumentGroup: _ctx.enterDocumentGroup,
                                                                onOnHoverItemAutocomplete: _ctx.onHoverItemAutocomplete,
                                                                class: "p-mb-2",
                                                                documentFields: _ctx.documentFields,
                                                                documentClassFields: group.fields,
                                                                id: group.id,
                                                                name: group.name,
                                                                description: group.description,
                                                                isReadOnlyMode: _ctx.isReadOnlyMode,
                                                                documentId: _ctx.documentId,
                                                                activeGroupTab: _ctx.activeGroupTab
                                                              }, null, 8, ["onOnBlur", "onOnFocusField", "onAllHeadRefFields", "onEnterDocumentGroup", "onOnHoverItemAutocomplete", "documentFields", "documentClassFields", "id", "name", "description", "isReadOnlyMode", "documentId", "activeGroupTab"])
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["header"]))
                                                        }), 128))
                                                  ]),
                                                  _: 1
                                                }, 8, ["activeIndex", "onTabChange"]))
                                              : (_openBlock(), _createBlock(_component_TabView, {
                                                  key: 2,
                                                  class: "p-px-2 custom"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (idx) => {
                                                      return _createVNode(_component_TabPanel, {
                                                        key: idx,
                                                        header: _ctx.$t('Squeeze.General.Loading')
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ValidationFieldSetSkeleton, { class: "p-mb-2" })
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["header"])
                                                    }), 64))
                                                  ]),
                                                  _: 1
                                                }))
                                        ], 64))
                        ], 6)
                      ], 2),
                      (!_ctx.showHeadTraining && !_ctx.showPositionTraining && !_ctx.showFormHeadTraining && !_ctx.showFormPositionTraining && !_ctx.showSplitDocument && !_ctx.showOcrResults && !_ctx.showLocatorTest && _ctx.tables.filter(t => !t.hidden).length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables.filter(t => !t.hidden), (table) => {
                              return (_openBlock(), _createBlock(_component_Button, {
                                class: "p-shadow-2 p-mr-1",
                                key: table.id,
                                label: table.description,
                                onClick: ($event: any) => (_ctx.setActiveTable(table.id))
                              }, null, 8, ["label", "onClick"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 4)
                  ]),
                  _: 1
                }, 512),
                _createVNode(_component_SplitterPanel, {
                  class: "p-d-flex",
                  size: 67,
                  minSize: 40
                }, {
                  default: _withCtx(() => [
                    (!_ctx.NEW_SQUEEZE_VIEWER)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_Viewer, {
                            documentId: _ctx.documentId,
                            class: "p-shadow-2",
                            style: {"height":"100%"}
                          }, null, 8, ["documentId"])
                        ], 512))
                      : (_openBlock(), _createBlock(_component_SqueezeViewer, {
                          key: 1,
                          documentData: _ctx.currentDocument,
                          documentId: _ctx.documentId,
                          serverBaseUrl: _ctx.serverBaseUrl,
                          docBaseUrl: _ctx.docBaseUrl,
                          authHeader: _ctx.getUserAuth,
                          drawingMode: _ctx.viewerDrawingMode,
                          selectedSpans: _ctx.viewerMarkedRegions,
                          observeResizing: _ctx.viewerShouldObserveResizing,
                          viewerSettings: JSON.parse(JSON.stringify(_ctx.store.state.userSettings.viewSettings.viewerSettings)),
                          showKositValidationReportFile: _ctx.showKositValidationReportFile,
                          ref: "SqueezeViewer",
                          style: {"height":"100%"},
                          onAreaSelected: _ctx.onViewerAreaSelected,
                          onOnMarkRegion: _ctx.onMarkRegion,
                          onToggleResultList: _ctx.toggleResultList,
                          onIsKositValidationReportFileDisplayed: _ctx.isKositValidationReportFileDisplayed
                        }, null, 8, ["documentData", "documentId", "serverBaseUrl", "docBaseUrl", "authHeader", "drawingMode", "selectedSpans", "observeResizing", "viewerSettings", "showKositValidationReportFile", "onAreaSelected", "onOnMarkRegion", "onToggleResultList", "onIsKositValidationReportFileDisplayed"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onMousedown", "onMouseup", "onResizeend"])
          ]),
          _: 1
        }),
        _createVNode(_component_SplitterPanel, {
          class: "p-d-flex",
          minSize: 25,
          size: 25,
          style: _normalizeStyle(!_ctx.showTableSplitter || !_ctx.showTableSplitterGutter || _ctx.activeTable.hidden ? 'display: none !important' : '')
        }, {
          default: _withCtx(() => [
            ((!_ctx.showHeadTraining && !_ctx.showPositionTraining && !_ctx.showFormHeadTraining && !_ctx.showFormPositionTraining && !_ctx.showSplitDocument && !_ctx.showOcrResults && !_ctx.showLocatorTest))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    (_ctx.loaded)
                      ? (_openBlock(), _createBlock(_component_ValidationTable, {
                          key: 0,
                          ref: el => { _ctx.tableInValidation[_ctx.activeTableId] = el },
                          onOnChange: _ctx.validateDocument,
                          onOnChangeTable: _ctx.changeTableData,
                          currentTable: _ctx.findTableIndex,
                          documentFields: _ctx.documentFields,
                          documentId: _ctx.documentId,
                          documentClassId: _ctx.documentClassId,
                          resetSelectedRows: _ctx.resetSelectedRows,
                          class: "p-shadow-4",
                          style: {"max-height":"100%"},
                          onOnFocusField: _ctx.onFocusTableCell,
                          onFocusLastHeadField: _ctx.focusLastHeadField,
                          hideButtons: _ctx.hideTableButtons,
                          isReadOnlyMode: _ctx.isReadOnlyMode,
                          onAllTableRefCells: _ctx.allTableRefCells,
                          customTableActions: _ctx.customTableActions,
                          onExecuteCustomTableAction: _ctx.executeCustomValidationAction
                        }, null, 8, ["onOnChange", "onOnChangeTable", "currentTable", "documentFields", "documentId", "documentClassId", "resetSelectedRows", "onOnFocusField", "onFocusLastHeadField", "hideButtons", "isReadOnlyMode", "onAllTableRefCells", "customTableActions", "onExecuteCustomTableAction"]))
                      : (_openBlock(), _createBlock(_component_ValidationFieldSetSkeleton, { key: 1 }))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["class", "onMousedown", "onMouseup", "onResizeend"]),
    _createVNode(_component_Sidebar, {
      visible: _ctx.showHotKeyList,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showHotKeyList) = $event)),
      baseZIndex: 1000,
      position: "right",
      modal: true,
      showCloseIcon: true,
      dismissable: true,
      onHide: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showHotKeyList = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_HotKeyList)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('Squeeze.Validation.Log.Log'),
      visible: _ctx.showLog,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showLog) = $event)),
      modal: true,
      closable: true,
      dismissableMask: true,
      baseZIndex: 1000,
      breakpoints: {'960px': '75vw', '640px': '100vw'},
      style: {width: '50vw'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LogView, { "document-id": _ctx.documentId }, null, 8, ["document-id"])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_DialogOptionsConfirm, {
      show: _ctx.dialogs.deleteDocument.display,
      options: _ctx.dialogs.deleteDocument.options,
      locales: _ctx.dialogs.deleteDocument.locales,
      onOnConfirm: _ctx.deleteDocument,
      onOnClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogs.deleteDocument.display = false))
    }, null, 8, ["show", "options", "locales", "onOnConfirm"]),
    _createVNode(_component_DialogOptionsConfirm, {
      show: _ctx.dialogs.suspendDocument.display,
      options: _ctx.dialogs.suspendDocument.options,
      locales: _ctx.dialogs.suspendDocument.locales,
      onOnConfirm: _ctx.suspendDocument,
      onOnClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogs.suspendDocument.display = false)),
      currentDocument: _ctx.currentDocument
    }, null, 8, ["show", "options", "locales", "onOnConfirm", "currentDocument"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('Squeeze.Validation.Email.SendMail'),
      visible: _ctx.dialogs.sendMail.display,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dialogs.sendMail.display) = $event)),
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ValidationEmailView, {
          documentId: _ctx.documentId,
          onSendSuccess: _ctx.afterSendSuccess,
          documentFields: _ctx.documentFields
        }, null, 8, ["documentId", "onSendSuccess", "documentFields"])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.dialogs.changeDocumentClass.display,
      onOnClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogs.changeDocumentClass.display = false)),
      onOnConfirm: _ctx.saveNewDocumentClass,
      headerText: _ctx.$t('Squeeze.Validation.Dialogs.ChangeDocumentClass.Change'),
      loading: _ctx.dialogs.changeDocumentClass.loading
    }, {
      content: _withCtx(() => [
        _createVNode(_component_DocumentClassChangeForm, {
          classificationClasses: _ctx.dialogs.changeDocumentClass.classificationClasses,
          trainDocument: _ctx.dialogs.changeDocumentClass.trainDocument,
          onOnChange: _ctx.onChangeDocumentClassChangeForm
        }, null, 8, ["classificationClasses", "trainDocument", "onOnChange"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "headerText", "loading"]),
    _createVNode(_component_DialogLocked, {
      showDialog: _ctx.dialogs.lockedDocument.display,
      lockingUserId: _ctx.lockingUserId,
      onCloseDialog: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogs.lockedDocument.display = false)),
      onShowOnly: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onClickDocumentReadOnly())),
      onBackToOverview: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goBackToValidationList())),
      onUnlockDocument: _cache[21] || (_cache[21] = ($event: any) => (_ctx.unlockViewedDocument())),
      onNextDocument: _cache[22] || (_cache[22] = ($event: any) => (_ctx.goToNextDocument(false)))
    }, null, 8, ["showDialog", "lockingUserId"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('Squeeze.Validation.General.AddAttachment'),
      visible: _ctx.showUpload,
      "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showUpload) = $event)),
      modal: true,
      closable: true,
      dismissableMask: true,
      baseZIndex: 1000,
      breakpoints: {'960px': '75vw', '640px': '100vw'},
      style: {width: '50vw'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FileUpload, {
          onSelect: _ctx.onSelectFiles,
          name: "documentFile",
          customUpload: true,
          onUploader: _ctx.fileUploader,
          multiple: true,
          showCancelButton: true,
          uploadFiles: _ctx.files,
          cancelLabel: _ctx.$t('Squeeze.General.Clear'),
          customProgress: _ctx.progress,
          fileContentHeight: '15.625rem',
          uploadLabel: _ctx.uploadLabel,
          chooseLabel: _ctx.$t('Squeeze.General.Choose'),
          onClear: _ctx.clearFiles,
          onRemoveFile: _ctx.removeFile,
          invalidFileSizeMessage: '{0}: ' + _ctx.$t('Squeeze.Validation.General.InvalidFileSize') + ' ' + '{1}'
        }, null, 8, ["onSelect", "onUploader", "uploadFiles", "cancelLabel", "customProgress", "uploadLabel", "chooseLabel", "onClear", "onRemoveFile", "invalidFileSizeMessage"])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showCustomActionDialog,
      onOnConfirm: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showCustomActionDialog = false)),
      onOnClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showCustomActionDialog = false)),
      headerText: _ctx.$t('PrimeVue.Message'),
      saveButtonText: _ctx.$t('Squeeze.General.Confirmation'),
      showAbortButton: false
    }, {
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.customActionDialogMessage), 1)
      ]),
      _: 1
    }, 8, ["show", "headerText", "saveButtonText"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('Squeeze.Validation.Dialogs.ErrorDocument.Label'),
      visible: _ctx.dialogs.errorDocument.display,
      "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dialogs.errorDocument.display) = $event)),
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('Squeeze.Queue.QueueList'),
          icon: "mdi mdi-transit-connection-horizontal",
          class: "p-button-text p-justify-end",
          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.goBackToQueueList()))
        }, null, 8, ["label"])
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Validation.Dialogs.ErrorDocument.Error')) + " ", 1)
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('Squeeze.System.Fail'),
      visible: _ctx.showExportError,
      "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.showExportError) = $event)),
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Message, {
          closable: false,
          severity: "error"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.exportErrorMessage), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}